import * as React from "react";
import { Link } from "gatsby";
import { darkButton, button } from "./product-button.module.css";

export function ProductButton({ className, to, ...props }) {
  const isInternal = /^\/(?!\/)/.test(to); // Regex to check if 'to' is an internal link

  if (isInternal) {
    // If internal link, use Gatsby Link
    return <Link className={[className, button].join(" ")} to={to} {...props} rel="alternate" hrefLang="en-SG"/>;
  } else {
    // If external link, use regular anchor tag
    return <a className={[className, button].join(" ")} href={to} {...props} rel="alternate" hrefLang="en-SG"/>;
  }
}
